import clsx from 'clsx';
import { Children, type PropsWithChildren, cloneElement, isValidElement } from 'react';
import { Modal as ReactModal } from 'react-bootstrap';
import { useModalContext } from './ModalContext';
import { VStack } from '../VStack';
import { Icon } from '../Icon';

export type ModalHeaderProps = {
  className?: string;
};

export const ModalHeader = (props: PropsWithChildren<ModalHeaderProps>) => {
  const { className, children } = props;
  const { purpose, color, onClose } = useModalContext();

  const headerChildren = Children.map(children, child => {
    return isValidElement(child) && child.type === 'h3'
      ? cloneElement(child, {
          // @ts-ignore
          className: clsx({
            'text-success': color === 'success',
            'text-info': color === 'info',
            'text-warning': color === 'warning',
            'text-danger': color === 'danger',
          }),
        })
      : child;
  });

  const icon =
    color === 'success' || color === 'info' ? 'check' : color === 'warning' ? 'alarm' : 'warning';

  return (
    <ReactModal.Header className={className}>
      {purpose === 'default' ? (
        // default modal type
        <>
          {headerChildren}
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={onClose}
          />
        </>
      ) : (
        // contextual modal type
        <VStack fullWidth verticalAlignment="center">
          <div
            className={clsx(
              'rounded-circle bg-opacity-10 d-flex align-items-center justify-content-center mb-4',
              {
                'bg-success': color === 'success',
                'bg-info': color === 'info',
                'bg-warning': color === 'warning',
                'bg-danger': color === 'danger',
              },
            )}
            style={{ width: '3rem', height: '3rem' }}
          >
            <Icon
              icon={icon}
              size="md"
              className={clsx({
                'text-success': color === 'success',
                'text-info': color === 'info',
                'text-warning': color === 'warning',
                'text-danger': color === 'danger',
              })}
            />
          </div>

          {headerChildren}
        </VStack>
      )}
    </ReactModal.Header>
  );
};
